import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0577e4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "gray-title"
}
const _hoisted_2 = { class: "gray-text-check" }
const _hoisted_3 = { class: "gray-text" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("移动分组")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_6 = {
  key: 0,
  class: "img-list"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "pic-title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      t: "1637563771695",
      class: "icon",
      viewBox: "0 0 1024 1024",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      "p-id": "8244",
      width: "20",
      height: "20"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M694.037333 213.333333v64H234.666667v469.333334h512V512h64v234.666667a64 64 0 0 1-64 64H234.666667a64 64 0 0 1-64-64V277.333333a64 64 0 0 1 64-64h459.370666z m136.746667 24.234667l45.098667 45.397333-343.722667 341.290667 0.128 0.128-46.592 1.578667 1.322667-47.274667 0.085333 0.106667 343.68-341.226667z",
        "p-id": "8245",
        fill: "#67C23A"
      })
    ])
  ])
], -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center","width":"60vw"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1637549814409",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "7200",
    width: "64",
    height: "64"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M855.6 427.2H168.5c-12.7 0-24.4 6.9-30.6 18L4.4 684.7C1.5 689.9 0 695.8 0 701.8v287.1c0 19.4 15.7 35.1 35.1 35.1H989c19.4 0 35.1-15.7 35.1-35.1V701.8c0-6-1.5-11.8-4.4-17.1L886.2 445.2c-6.2-11.1-17.9-18-30.6-18zM673.4 695.6c-16.5 0-30.8 11.5-34.3 27.7-12.7 58.5-64.8 102.3-127.2 102.3s-114.5-43.8-127.2-102.3c-3.5-16.1-17.8-27.7-34.3-27.7H119c-26.4 0-43.3-28-31.1-51.4l81.7-155.8c6.1-11.6 18-18.8 31.1-18.8h622.4c13 0 25 7.2 31.1 18.8l81.7 155.8c12.2 23.4-4.7 51.4-31.1 51.4H673.4zM819.9 209.5c-1-1.8-2.1-3.7-3.2-5.5-9.8-16.6-31.1-22.2-47.8-12.6L648.5 261c-17 9.8-22.7 31.6-12.6 48.4 0.9 1.4 1.7 2.9 2.5 4.4 9.5 17 31.2 22.8 48 13L807 257.3c16.7-9.7 22.4-31 12.9-47.8zM375.4 261.1L255 191.6c-16.7-9.6-38-4-47.8 12.6-1.1 1.8-2.1 3.6-3.2 5.5-9.5 16.8-3.8 38.1 12.9 47.8L337.3 327c16.9 9.7 38.6 4 48-13.1 0.8-1.5 1.7-2.9 2.5-4.4 10.2-16.8 4.5-38.6-12.4-48.4zM512 239.3h2.5c19.5 0.3 35.5-15.5 35.5-35.1v-139c0-19.3-15.6-34.9-34.8-35.1h-6.4C489.6 30.3 474 46 474 65.2v139c0 19.5 15.9 35.4 35.5 35.1h2.5z",
      "p-id": "7201",
      fill: "#8a8a8a"
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "暂无数据")
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 移动素材到 ")
const _hoisted_14 = { style: {"color":"#409eff"} }
const _hoisted_15 = { class: "move-block" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { style: {"text-align":"center"} }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("移动")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_checkbox = _resolveComponent("n-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_n_checkbox_group = _resolveComponent("n-checkbox-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.checkList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_2, [
              _createVNode(_component_n_checkbox, {
                checked: _ctx.isChooseAll,
                "onUpdate:checked": _ctx.chooseAll,
                label: "全选"
              }, null, 8, ["checked", "onUpdate:checked"])
            ]),
            _createElementVNode("span", _hoisted_3, "已选择 " + _toDisplayString(_ctx.getCount()) + " 项内容", 1)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, {
              type: "text",
              onClick: _ctx.showMoveDialog
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "text",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deletePic(_ctx.checkList)))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_n_checkbox_group, {
        value: _ctx.checkList,
        "onUpdate:value": [
          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkList) = $event)),
          _ctx.handleUpdateValue
        ]
      }, {
        default: _withCtx(() => [
          (_ctx.picList.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.picList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "img-item",
                    key: item.id
                  }, [
                    _createElementVNode("img", {
                      class: "img-block",
                      src: 
              'https://facemaster.meb.fit/api/face/getOssImage?fileName=' +
              item.mouldImgName[0] +
              '&style=image/auto-orient,1/resize,m_lfit,w_70/quality,q_90'
            
                    }, null, 8, _hoisted_7),
                    _createVNode(_component_n_checkbox, {
                      value: item.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", null, _toDisplayString(item.mouldTitle), 1),
                          _createVNode(_component_el_popover, {
                            title: "编辑名称",
                            placement: "right",
                            width: 400,
                            trigger: "click"
                          }, {
                            reference: _withCtx(() => [
                              _hoisted_9
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: item.mouldTitle,
                                "onUpdate:modelValue": ($event: any) => ((item.mouldTitle) = $event),
                                onChange: ($event: any) => (_ctx.editName(item)),
                                onKeyup: _withKeys(($event: any) => (_ctx.editName(item)), ["enter"])
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "onKeyup"])
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
        ]),
        _: 1
      }, 8, ["value", "onUpdate:value"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "移动分组",
      modelValue: _ctx.isShowMove,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isShowMove) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, [
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.moveSelect.mouldGroupName), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupList, (item) => {
            return (_openBlock(), _createElementBlock("p", {
              class: "move-block-item",
              key: item.id,
              style: _normalizeStyle({ color: _ctx.moveSelect.id == item.id ? '#409EFF' : '#2c3e50' }),
              onClick: ($event: any) => (_ctx.chooseMove(item))
            }, _toDisplayString(item.mouldGroupName), 13, _hoisted_16))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_button, {
            onClick: _ctx.move,
            type: "success"
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, { onClick: _ctx.cancelMove }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}